<!-- 任务状态Column -->
<template>
    <div>
      {{ row['status'] === 1 ? $t('text.Activated') : $t('integration.stop_it') }}
    </div>
</template>

<script>
export default {
    props: ['row'],
    data() {
        return {

        }
    }
}
</script>